import { RouteRecordRaw } from "vue-router";

export const custAndOrgRoutes: RouteRecordRaw[] = [
  {
    path: "/entities",
    children: [
      {
        path: "",
        name: "entities",
        meta: {
          requiresStaff: true,
        },
        component: () => import("../../views/customers-and-organizations/Entities.vue"),
      },
      {
        path: ":id/edit",
        name: "entity-edit",
        meta: {
          requiresAuth: true,
          requiresOrgOrCust: true,
        },
        component: () => import("../../views/customers-and-organizations/Edit.vue"),
      },
      {
        path: ":id",
        meta: {
          requiresAuth: true,
          requiresOrgOrCust: true,
        },
        name: "entity-index",
        component: () => import("../../views/customers-and-organizations/Index.vue"),
        children: [
          {
            path: "",
            name: "entity-home",
            // Index.vue redirects to the first tab once it knows the entity type
            component: { render: () => null },
          },
          {
            path: "home",
            name: "entity-home-abs",
            component: () => import("../../views/customers-and-organizations/Home.vue"),
          },
          {
            path: "users",
            name: "entity-users",
            component: () => import("../../views/customers-and-organizations/Users.vue"),
          },
          {
            path: "mimboxes",
            name: "entity-mimboxes",
            component: () => import("../../views/customers-and-organizations/Mimboxes.vue"),
          },
          {
            path: "settings",
            name: "entity-settings",
            meta: {
              requiresStaff: true,
            },
            component: () => import("../../views/customers-and-organizations/Settings.vue"),
          },
          {
            path: "files",
            name: "entity-files",
            meta: {
              requiresStaff: true,
            },
            component: () => import("../../views/customers-and-organizations/Files.vue"),
          },
        ],
      },
    ],
  },
];
